const formatSiteLink = (link) => {
  return link.replace(/^https?\:\/\//i, '')
}
const ensureHttps = (link) => {
  const trimmed = link?.trim()
  if (!trimmed) return trimmed || ''
  return `https://${trimmed.replace(/^https?:\/\//i, '')}`
}
function getDomainName(url) {
  try {
    const { hostname } = new URL(url)
    return hostname.replace(/^www\./, '')
  } catch (error) {
    return null
  }
}
export { formatSiteLink, getDomainName, ensureHttps }
